import { mutatorAction } from "satcheljs";
import { appViewState } from "sh-application/store";

export default mutatorAction("SET_THEME_NAME",
    function setThemeName(
        themeName: string) {
        appViewState().themeName = themeName;
    });